import { useState } from "react";
import CopyCode from "../../CopyCode/CopyCode";

const DataTable = () => {
  return (
    <div className="flex flex-col gap-y-10 p-6">
      {/* BASIC TABLES */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-white mb-6">Data Tables</h2>
        <div className="grid grid-cols-1 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-x-auto">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Simple Table</label>
            <table className="w-full text-sm text-slate-300">
              <thead className="bg-slate-800">
                <tr>
                  <th className="px-3 py-2 text-left">Name</th>
                  <th className="px-3 py-2 text-left">Email</th>
                  <th className="px-3 py-2 text-left">Role</th>
                </tr>
              </thead>
              <tbody>
                {[{name: "Alice", email: "alice@co.com", role: "Admin"}, {name: "Bob", email: "bob@co.com", role: "User"}].map(row => (
                  <tr key={row.name} className="border-t border-slate-600 hover:bg-slate-800">
                    <td className="px-3 py-2">{row.name}</td>
                    <td className="px-3 py-2">{row.email}</td>
                    <td className="px-3 py-2">{row.role}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<table className="w-full text-sm">
  <thead className="bg-slate-800">
    <tr>
      <th className="px-3 py-2 text-left">Column</th>
    </tr>
  </thead>
  <tbody>
    <tr className="border-t">
      <td className="px-3 py-2">Data</td>
    </tr>
  </tbody>
</table>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-x-auto">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Striped Table</label>
            <table className="w-full text-sm text-slate-300">
              <thead className="bg-slate-800">
                <tr>
                  <th className="px-3 py-2 text-left">ID</th>
                  <th className="px-3 py-2 text-left">Status</th>
                </tr>
              </thead>
              <tbody>
                {[1,2,3,4].map(i => (
                  <tr key={i} className={`border-t border-slate-600 ${i % 2 === 0 ? "bg-slate-800" : ""}`}>
                    <td className="px-3 py-2">#{i}</td>
                    <td className="px-3 py-2"><span className="px-2 py-1 bg-green-900 text-green-200 rounded text-xs">Active</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<tbody>
  <tr className={i % 2 === 0 ? "bg-slate-800" : ""}>
    <td className="px-3 py-2">Data</td>
  </tr>
</tbody>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-x-auto">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Hover Effects</label>
            <table className="w-full text-sm text-slate-300">
              <tbody>
                {["Product A", "Product B", "Product C"].map(name => (
                  <tr key={name} className="border-b border-slate-600 hover:bg-slate-700 hover:text-slate-100 transition cursor-pointer">
                    <td className="px-3 py-3">{name}</td>
                    <td className="px-3 py-3 text-right">$99</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<tr className="hover:bg-slate-700 hover:text-slate-100 transition cursor-pointer">
  <td className="px-3 py-3">Item</td>
  <td className="text-right">Price</td>
</tr>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-x-auto">
            <label className="text-xs text-slate-400 mb-3 block font-medium">With Actions</label>
            <table className="w-full text-sm text-slate-300">
              <thead className="bg-slate-800">
                <tr>
                  <th className="px-3 py-2 text-left">Item</th>
                  <th className="px-3 py-2 text-right">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-t border-slate-600">
                  <td className="px-3 py-2">User Data</td>
                  <td className="px-3 py-2 text-right space-x-1">
                    <button className="px-2 py-1 bg-blue-900 text-blue-300 text-xs rounded hover:bg-blue-800">Edit</button>
                    <button className="px-2 py-1 bg-red-900 text-red-300 text-xs rounded hover:bg-red-800">Delete</button>
                  </td>
                </tr>
              </tbody>
            </table>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<button className="px-2 py-1 bg-blue-900 text-xs rounded">Edit</button>
<button className="px-2 py-1 bg-red-900 text-xs rounded">Delete</button>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-x-auto">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Compact Table</label>
            <table className="w-full text-xs text-slate-300">
              <thead className="bg-slate-800">
                <tr>
                  <th className="px-2 py-1 text-left">Ref</th>
                  <th className="px-2 py-1">Value</th>
                </tr>
              </thead>
              <tbody>
                {[1,2,3].map(i => (
                  <tr key={i} className="border-t border-slate-600">
                    <td className="px-2 py-1">REF-{i}</td>
                    <td className="px-2 py-1">Data-{i}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<table className="w-full text-xs">
  <tr>
    <th className="px-2 py-1">Ref</th>
  </tr>
</table>`} />
          </div>
        </div>
      </div>

      {/* STYLED TABLES */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-amber-400 mb-6">Styled Tables</h2>
        <div className="grid grid-cols-1 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-x-auto">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Bordered Table</label>
            <table className="w-full text-sm text-slate-300 border border-slate-600">
              <thead className="bg-slate-800 border-b border-slate-600">
                <tr>
                  <th className="px-3 py-2 border-r border-slate-600">Name</th>
                  <th className="px-3 py-2">Status</th>
                </tr>
              </thead>
              <tbody>
                {["Active", "Pending"].map((s, i) => (
                  <tr key={i} className="border-b border-slate-600">
                    <td className="px-3 py-2 border-r border-slate-600">Item {i}</td>
                    <td className="px-3 py-2">{s}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<table className="border border-slate-600">
  <thead className="border-b border-slate-600">
    <tr>
      <th className="border-r border-slate-600">Name</th>
    </tr>
  </thead>
</table>`} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DataTable;


